document.addEventListener('DOMContentLoaded', () => {
  const locationNextButton = document.getElementById("locationNextButton");
  const locationEditButton = document.getElementById("locationEditButton");
  const timeNextButton = document.getElementById("timeNextButton");
  const timeEditButton = document.getElementById("timeEditButton");
  const calendarContainer = document.querySelector(".calendar-container");
  const formContainer = document.querySelector(".form-container");
  const venueOptions = document.getElementById("venueOptions");
  const venueSelection = document.getElementById("venueSelection");
  const venueText = document.querySelector(".venueSelection-Location");
  const phoneInput = document.getElementById('phone');
  const phoneGroup = document.querySelector('.phone-group');
  const countrySelect = document.getElementById('countrySelect');
  const countryCodeSpan = document.getElementById('countryCode');
  const form = document.getElementById('appointmentForm');
  const emailInput = document.getElementById('email');
  const emailGroup = document.querySelector('.email-group');
  const bookButton = document.getElementById('bookButton');

  // Get all radio inputs within the venueOptions container
  const radioInputs = document.querySelectorAll('#venueOptions input[type="radio"]');
  
  // Add event listener to each radio input
  radioInputs.forEach(radio => {
      radio.addEventListener('change', (event) => {
          if (event.target.checked) {
              // Remove disabled attribute from the next button
              locationNextButton.removeAttribute('disabled');
          }
      });
  });

  // Function to get query parameters
  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Get "location" parameter from URL
  const locationParam = getQueryParam("location");

  if (locationParam) {
    // Find the matching radio input by value
    const radioInput = document.querySelector(`input[name="venue"][value="${locationParam}"]`);
    
    // If a matching input is found, select it
    if (radioInput) {
        radioInput.checked = true;
        locationNextButton.removeAttribute('disabled');
    }
  }

  function handleLocationNextButtonClick() {
    // Find the selected radio button
    const selectedRadio = document.querySelector('input[name="venue"]:checked');
    if (!selectedRadio) {
        console.error("Please select a venue before proceeding.");
        return;
    }
    
    let selectedVenue = selectedRadio.value;
    const label = document.querySelector(`label[for="${selectedVenue}"]`);
    let selectedVenueLabel = label ? label.textContent.trim() : "Unknown Venue";
    let selectedInstance = sesamiInstances[selectedVenue];

    if (!selectedInstance) {
        console.error(`No Sesami instance found for venue: ${selectedVenue}`);
        return;
    }

    // Hide venueOptions and show venueSelection
    toggleVenueSelection(selectedVenueLabel);

    // Instantiate the calendar for the selected venue
    instantiateCalendar(selectedInstance);

    locationNextButton.classList.add("small-hide", "medium-hide", "large-up-hide");
    calendarContainer.classList.remove("small-hide", "medium-hide", "large-up-hide");
    locationEditButton.classList.remove("small-hide", "medium-hide", "large-up-hide");
    document.querySelector("#timeSelection").classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 2 Selected Time

  }

  function toggleVenueSelection(selectedVenue) {    
    if (!venueOptions || !venueSelection || !venueText) {
        console.error("One or more elements are null.");
        return;
    }
    // Hide venueOptions and show venueSelection
    venueOptions.classList.add("small-hide", "medium-hide", "large-up-hide");
    venueSelection.classList.remove("small-hide", "medium-hide", "large-up-hide");

    // Update the venue name inside #venueSelection
    venueText.innerText = selectedVenue.charAt(0).toUpperCase() + selectedVenue.slice(1); // Capitalize first letter
  }


  function handleLocationEditButtonClick() {
    venueSelection.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 1 Selected Venue
    formContainer.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 3 Input Form
    calendarContainer.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 2 Input Form
    timeEditButton.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 2 Next Button
    locationEditButton.classList.add("small-hide", "medium-hide", "large-up-hide");

    venueOptions.classList.remove("small-hide", "medium-hide", "large-up-hide"); // Step 1 Input Form
    locationNextButton.classList.remove("small-hide", "medium-hide", "large-up-hide"); // Step 1 Submit
    
    const timeSelectors = document.querySelector("#timeSelectors");
    timeSelectors.innerHTML = ""; // Clear existing contents
    timeNextButton.setAttribute("disabled", ""); // Disable time Next Button


  }

  // Attach event listeners
  locationNextButton.addEventListener("click", handleLocationNextButtonClick);
  locationEditButton.addEventListener("click", handleLocationEditButtonClick);

  // Event listener for the Edit Button of Date and Time Select
  function handleTimeEditButtonClick() {
    
    // Show Step 2 Related Data and Hide All Others
    // locationNextButton.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 1 Submit
    formContainer.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 3 Input
    venueOptions.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 1 Input
    document.querySelector("#timeSelection").classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 2 Selected Time
    timeEditButton.classList.add("small-hide", "medium-hide", "large-up-hide"); // Step 2 Edit
    locationEditButton.classList.add("small-hide", "medium-hide", "large-up-hide");
    
    calendarContainer.classList.remove("small-hide", "medium-hide", "large-up-hide"); // Step 2 Input Form
    timeNextButton.classList.remove("small-hide", "medium-hide", "large-up-hide"); // Step 2 Submit 
  };

  // Event listener for the Next Button of Date and Time Select
  function handleTimeNextButtonClick() {
    const selectedSlotData = JSON.parse(document.querySelector('input[name="time-availability"]:checked').dataset.slot);
    
    // Convert the datetime string to a Date object
    const dateObj = new Date(selectedSlotData.startTime);
    
    // Format the date and time with the correct structure
    const formattedDateTime = dateObj.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      // hour: 'numeric',
      // minute: '2-digit',
      // hour12: true
    })//.replace(/,/, '').replace(/at/, '').replace(/(\d+)\s*(\d{4})/, '$1, $2 at');;
    
    // Update the element with the formatted date and time
    document.querySelector('.timeSelection-date-time').textContent = formattedDateTime;
    
    // Rest of your existing code
    calendarContainer.classList.add("small-hide", "medium-hide", "large-up-hide");
    formContainer.classList.remove("small-hide", "medium-hide", "large-up-hide");
    timeEditButton.classList.remove("small-hide", "medium-hide", "large-up-hide");
    locationEditButton.classList.remove("small-hide", "medium-hide", "large-up-hide");
    document.querySelector("#timeSelection").classList.remove("small-hide", "medium-hide", "large-up-hide");
  };

  timeNextButton.addEventListener("click", handleTimeNextButtonClick);
  timeEditButton.addEventListener("click", handleTimeEditButtonClick);


  // Update phone country code on dropdown change
  countrySelect.addEventListener('change', (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const countryCode = selectedOption.getAttribute('data-code');
    countryCodeSpan.textContent = countryCode;
  });
  
  // Event listener for the Book Appointment Button
  document.getElementById('bookButton').addEventListener('click', (e) => {
    e.preventDefault(); // Prevent form submission
    
    let customer = {
      email: document.getElementById('email').value,
      firstName: document.getElementById('firstName').value,
      lastName: document.getElementById('lastName').value,
      phone: document.getElementById('countryCode').innerText + document.getElementById('phone').value
    }
    
    const eventDate = document.querySelector("input[name='properties[Event Date]']")?.value.trim() || "";

    // Get options information from form
    let options = {
      properties: [
        {
          name: "Email",
          value: document.getElementById('email').value
        },
        {
          name: "Contact number",
          value: document.getElementById('countryCode').innerText + document.getElementById('phone').value
        },
        {
          name: "Customer contact method",
          value: document.querySelector("input[name='properties[Customer contact method]']:checked").value
        },
        {
          name: "Purpose of visit",
          value: document.querySelector("input[name='properties[Purpose of visit]']:checked").value
        },
        {
          name: "Additional information",
          value: document.getElementById('additional_information').value || ''
        },
        {
          name: "Event Date",
          value: eventDate
        }
      ]
    };

    const selectedSlotData = JSON.parse(document.querySelector('input[name="time-availability"]:checked').dataset.slot);

    // Find the selected radio button
    const selectedVenue = document.querySelector('input[name="venue"]:checked')?.value;
    if (selectedVenue) {
      // Show loading state
      const bookButton = document.getElementById('bookButton');
      bookButton.innerHTML = `
        <div class="loading-spinner" style="margin:0 auto; width: 20px; height: 20px; border: 2px solid #f3f3f3; 
        border-top: 2px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite;">
        </div>
      `;

      const selectedInstance = sesamiInstances[selectedVenue];
      selectedInstance.book(selectedSlotData, customer, options).then(() => {
        displayBookingDetails(selectedSlotData, selectedVenue, selectedInstance)
        .catch(e => {
          console.error('Error in displayBookingDetails:', e);
          showErrorToast('Error displaying booking details. Please try again.');
        });
      })
      .catch((e) => {
        console.error(e);   
        showErrorToast('The selected time slot has been taken. Please select a new time.');
        bookButton.innerHTML = 'Book Appointment'
      });
    } else {
      console.error(e);
      showErrorToast('Please select a venue before proceeding.');
    }
  });

  // Display appointment details when booking
  async function displayBookingDetails(selectedSlotData, selectedVenue, selectedInstance) {
    try {
      // Convert the datetime string to a Date object
      const dateObj = new Date(selectedSlotData.startTime);

      // Fetch the updated location from the selectedInstance
      const location = selectedInstance.config.product.location
      // Get the location and format it by replacing spaces with plus signs
      const formattedLocation = location.replace(/\s+/g, '+');
  
      // Format and update date and time
      const dateFormatter = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
      
      const timeFormatter = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      
      // Update date and time
      document.querySelector('.booking-date').textContent = dateFormatter.format(dateObj);
      document.querySelector('.booking-time').textContent = timeFormatter.format(dateObj);
      
      // Update store address
      document.querySelector('.booking-address').textContent = location;
  
      // Create the new iframe src with the formatted location
      const mapSrc = `https://www.google.com/maps/embed/v1/place?q=${formattedLocation}&key=AIzaSyDzzvzrYv9DQPNRk8J1J7xd4yvtLA8Md4k`;
      
      // Update the iframe src
      document.querySelector('.gmaps-container iframe').src = mapSrc;
      
      // Find the matching venue and update phone number
      const venueInfo = window.bookingVenues.find(venue => venue.name === selectedVenue);
      if (venueInfo) {
        document.querySelector('.booking-contact').textContent = `+${venueInfo.phone}`;
      }
  
      // Simple delay to allow iframe to load
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      // Update location in the appointment text
      // document.querySelector('.appointment-location').textContent = selectedInstance.config.title;
      document.querySelector('.booking-details-container').classList.remove('small-hide', 'medium-hide', 'large-up-hide');
      document.querySelector('.booking-container').classList.add('small-hide', 'medium-hide', 'large-up-hide');
      document.querySelector('.gmaps-container').classList.remove('small-hide', 'medium-hide', 'large-up-hide');
    } catch (e) {
      console.error('Error in displayBookingDetails:', e);
      throw e; // Re-throw to be caught by the caller
    }
   
  }
    
  // Prevent non-numeric input on phone field
  phoneInput.addEventListener('input', function(e) {
    this.value = this.value.replace(/\D/g, '');
  });
  
  // Add input event listener to the form
  form.addEventListener('input', function() {
    validateForm();
  });
  
  // Add change event listener for radio buttons
  form.addEventListener('change', function() {
    validateForm();
  });

  function validatePhoneForE164(phoneNumber) {
    const regEx = /^\+[1-9]\d{10,14}$/;
    return regEx.test(phoneNumber);
  }
  
  function validateEmail(email) {
    const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regEx.test(email);
  }

  function validateForm() {
    const firstName = document.getElementById('firstName').value.trim();
    const lastName = document.getElementById('lastName').value.trim();
    const email = document.getElementById('email').value.trim();
    const phone = document.getElementById('countryCode').innerText + document.getElementById('phone').value.trim();
    const contactMethod = document.querySelector("input[name='properties[Customer contact method]']:checked");
    const purposeOfVisit = document.querySelector("input[name='properties[Purpose of visit]']:checked");
    const eventDate = document.querySelector("input[name='properties[Event Date]']")?.value.trim() || "";
    
    // Validate email and phone
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhoneForE164(phone);
    
    // Update UI feedback for email and phone
    if (email) {
      isEmailValid ? emailGroup.classList.remove('error') : emailGroup.classList.add('error');
    }
    
    if (phone) {
      isPhoneValid ? phoneGroup.classList.remove('error') : phoneGroup.classList.add('error');
    }
    
    // Check if required fields are filled
    const requiredFieldsFilled = firstName && 
                               lastName && 
                               email && 
                               phone && 
                               contactMethod && 
                               purposeOfVisit &&
                               eventDate;
    
    // Update button state
    bookButton.disabled = !(requiredFieldsFilled && isEmailValid && isPhoneValid);
    
    return requiredFieldsFilled && isEmailValid && isPhoneValid;
  }

  // Function to observe changes
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Ensure it's an element
                  checkAndModifyArrows(node);
              }
          });
  
          // Also check all existing `.vc-arrow` elements in case of direct attribute modifications
          document.querySelectorAll('.calendar-container .vc-arrow').forEach(checkAndModifyArrows);
      });
  });
  
  // Function to check and modify `.vc-arrow` elements
  function checkAndModifyArrows(element) {
      if (element.classList.contains('vc-arrow')) {
          if (element.style.visibility === 'hidden') {
              element.style.visibility = ''; // Remove inline style
              element.classList.add('disabled'); // Add disabled class
          }
      }
  }
  
  // Target the calendar container
  const targetNode = document.querySelector('.calendar-container');
  
  if (targetNode) {
    observer.observe(targetNode, {
          childList: true, // Observe direct children
          subtree: true,   // Observe all descendants
          attributes: true, // Observe attribute changes
          attributeFilter: ['style'] // Only watch for style changes
      });

    // Initial check in case elements are already present
    document.querySelectorAll('.calendar-container .vc-arrow').forEach(checkAndModifyArrows);
  }

});

// Declare calendar variable
let calendar;

async function instantiateCalendar() {

  let selectedVenue = document.querySelector('input[name="venue"]:checked').value;
  let selectedInstance = sesamiInstances[selectedVenue];
  const todayDateObj = new Date();
  selectedInstance.setDate(todayDateObj);
  const calendarContainer = document.querySelector(".calendar-container");
  // Get all dates with available slots
  const unavailableDays = await getAllUnavailabilities(selectedInstance);
 

  // Destructure the Calendar constructor
  const { Calendar } = window.VanillaCalendarPro;

  const options = {
    type: 'default',
    selectedTheme: 'light',
    disableDates: unavailableDays,
    timezone: 'Asia/Singapore',
    selectionYearsMode: 'only-arrows',
    dateMin: 'today',
    selectionMonthsMode: 'only-arrows',
    layouts: {
      default: `
        <div class="vc-header" data-vc="header" role="toolbar" aria-label="Calendar Navigation">
          <div class="vc-header__content" data-vc-header="content">
            <#Month /> <#Year />  
          </div>
          <#ArrowPrev />
          <#ArrowNext />
        </div>
        <div class="vc-wrapper" data-vc="wrapper">
          <#WeekNumbers />
          <div class="vc-content" data-vc="content">
            <#Week />
            <#Dates />
            <#DateRangeTooltip />
          </div>
        </div>
      `
    },
    onClickDate(self, event) {
      let month = event.srcElement.parentElement.getAttribute("data-vc-date-month");
      selectedVenue = document.querySelector('input[name="venue"]:checked').value;
      selectedInstance = sesamiInstances[selectedVenue];
      let updateCalendar = () => {
        getAllUnavailabilities(selectedInstance).then((newUnavailableDays) => {
          calendar.disableDates = newUnavailableDays;
          calendar.update({
            year: false,
            month: false,
            dates: false
          });
          calendar.show();
        });
      };
      if (month == "prev") {
        calendar.hide();
        selectedInstance.previous("month");
        updateCalendar();
      } else if (month == "next") {
        calendar.hide();
        selectedInstance.next("month");
        updateCalendar();
      } 
      date = self.context.selectedDates[0];
      const dateObj = new Date(date);
      selectedInstance.setDate(dateObj);
      processSelectedDates(self, selectedInstance);

    },
    onClickArrow(self, event) {
        calendar.hide();
        timeNextButton.setAttribute("disabled", ""); // Disable time Next Button
        selectedVenue = document.querySelector('input[name="venue"]:checked').value;
        selectedInstance = sesamiInstances[selectedVenue];
        let updateCalendar = () => {
          getAllUnavailabilities(selectedInstance).then((newUnavailableDays) => {
            calendar.disableDates = newUnavailableDays;
            calendar.update({
              year: false,
              month: false,
              dates: false
            });
            calendar.show();
          });
        };

        if (event.target.classList.contains("vc-arrow_next")) {
          selectedInstance.next("month");
          updateCalendar();
        } else {
          selectedInstance.previous("month");
          updateCalendar();
        }
        const timeSelectors = document.querySelector("#timeSelectors");
        timeSelectors.innerHTML = ""; // Clear existing contents
    }
  };

  // If calendar has the "vc" class, update it; otherwise, initialize it
  if (document.getElementById("calendar")?.classList.contains("vc")) {
    calendar.disableDates = unavailableDays;
    calendar.update(); // Update the calendar instance
    calendarContainer.style.display = 'block';  // Show the calendar
  } else {
    calendar = new Calendar('#calendar', options);  // New instance
    calendar.init();  // Initialize the calendar
  }

  locationEditButton.addEventListener("click", () => {
    calendarContainer.style.display = 'none';
  });
}

async function getAllUnavailabilities(sesamiInstance) {
  if (!sesamiInstance.data || !sesamiInstance.data.rows) {
    console.error('SesamiInstance data is not available.');
    return [];
  }

  const unavailabilities = [];
  const today = new Date();

  let firstMonday = sesamiInstance.data.rows[0][0].date.getDate()

  if (firstMonday == 2) {
    // fetchAvailabilitiesDirectly(sesamiInstance);
  }

  for (let row of sesamiInstance.data.rows) {
    for (let day of row) {
      const dayDate = day.date;
      const todayStartOfDay = new Date(today);
      todayStartOfDay.setHours(0, 0, 0, 0);

      // Skip days not in the current month or in the past
      if (dayDate < todayStartOfDay) {
        const formattedDate = sesamiInstance.formatDate(dayDate, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });

        // Convert to the desired YYYY-MM-DD format if needed
        const parts = formattedDate.split('/');
        const localFormattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`; // YYYY-MM-DD
        unavailabilities.push(localFormattedDate);          
      } else {
        try {
          const slots = await day.getAvailabilities();

          
          if (slots?.length < 1) {
            const formattedDate = sesamiInstance.formatDate(dayDate, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });

          // Convert to the desired YYYY-MM-DD format if needed
          const parts = formattedDate.split('/');
          const localFormattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`; // YYYY-MM-DD
          unavailabilities.push(localFormattedDate);
          //

          }
        } catch (error) {
          console.error(`Error getting unavailabilities for ${dayDate}:`, error);
        }
      }

      
    }
  }

  return unavailabilities;
}

// Show or hide time slots when date is selected
async function processSelectedDates(self, sesamiInstance) {
  if (!self?.context?.selectedDates || !Array.isArray(self.context.selectedDates)) {
    console.error("Invalid or missing selectedDates.");
    return;
  }

  const selectedDate = self.context.selectedDates[0];
  // console.log("Selected Date:", selectedDate);

  let matchingDay = null;

  for (const row of sesamiInstance.data.rows) {
    matchingDay = row.find(day => {
      const dayDate = new Date(day.date); // ISO date
      const localDayDate = dayDate.toLocaleDateString("en-CA"); // Convert to YYYY-MM-DD in local time

      // console.log(`Converted Day Date: ${localDayDate}, Selected Date: ${selectedDate}, Match: ${localDayDate === selectedDate}`);
      return localDayDate === selectedDate;
    });

    if (matchingDay) {
      // console.log("Found matching day:", matchingDay);

      // Get availabilities for the matching day
      const availabilities = await matchingDay.getAvailabilities();

      // Create div elements for each availability
      const container = document.createElement("div");
      container.classList.add("availability-container");

      availabilities.forEach(slot => {
        // Create a label to style the radio button like a button
        const label = document.createElement("label");
        label.classList.add("slot", "button"); // Add classes for styling
      
        // Create the radio button input
        const radioButton = document.createElement("input");
        radioButton.type = "radio"; // Set input type to radio
        radioButton.name = "time-availability"; // Group all radio buttons
        radioButton.classList.add("slot-radio"); // Add custom class for additional styling
        radioButton.value = slot.startTime; // Store the startTime as value of the radio button
      
        // Store the entire slot data in the data attribute for later use
        radioButton.dataset.slot = JSON.stringify(slot);
      
        // Add an event listener (optional)
        radioButton.addEventListener("change", () => {
          // Access slot data when radio button is selected
          const selectedSlotData = JSON.parse(radioButton.dataset.slot);
        });
      
        // Add the time text content in the label
        const timeComponent = slot.startTime.split(" ")[1]; // Extract time only
        const [hours, minutes] = timeComponent.split(":"); // Split into hours and minutes
        
        
        // Format the time string
        label.textContent = `${hours}:${minutes}`;
        
        // Append the radio button input and label text
        label.insertBefore(radioButton, label.firstChild); // Radio button comes before label text
        
        // Append the label to the container
        container.appendChild(label);
      });


      // Event Listener for time selection
      container.addEventListener('change', (event) => {
      // Check if the changed element is a radio button
        if (event.target.type === 'radio') {
          // Find the next button and remove the disabled attribute
          timeNextButton.removeAttribute('disabled');
        }
      });

      // Create separator
      const hr = document.createElement("hr");
      hr.classList.add("time-separator");

      
      // Replace the contents of #timeSelectors
      const timeSelectors = document.querySelector("#timeSelectors");
      timeSelectors.innerHTML = ""; // Clear existing contents
      timeSelectors.appendChild(hr); // Add the new container
      timeSelectors.appendChild(container); // Add the new container
      

      // --- ADD THIS BLOCK: auto-select the first available slot ---
      const firstRadio = container.querySelector('input[type="radio"]');
      if (firstRadio) {
        // select it
        firstRadio.checked = true;

        // fire events so any listeners (including your 'change' enabler) run
        firstRadio.dispatchEvent(new Event('input', { bubbles: true }));
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));

        // ensure the Next button is enabled (belt & suspenders)
        const timeNextButton = document.getElementById("timeNextButton");
        if (timeNextButton) timeNextButton.removeAttribute('disabled');

        // optional UX nicety: focus/mark the selected label
        firstRadio.closest('label')?.classList.add('is-selected');

        
      }
      // --- END ADD ---
      break;
    }
  }

  if (!matchingDay) {
    console.warn(`No matching data found for the selected date: ${selectedDate}`);
  }
}

function showErrorToast(message) {
  const toast = document.querySelector('.error-toast');
  toast.textContent = message;

  toast.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
  // Remove toast after 3 seconds
  setTimeout(() => toast.classList.add('small-hide', 'medium-hide', 'large-up-hide'), 3000);
}

